// events
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import WebbDividerSmall from "../webb/webb-divider-sm";
import WebbDividerMedium from "../webb/webb-divider-md";
import WebbModuleInfo from "../webb/webb-module-info";
import FormNeeded from "../webb/form-needed";
import WebbLoader from "../webb/webb-loader";

import { UserForm } from "../../services/srvc-utilities";
import { GetLocalUser, GetLocalBusiness } from "../../services/srvc-auth-user";
import { CreateEvents } from "../../services/srvc-events-realm";

import CredsFileSaveFirebase from "../../services/srvc-creds-fbse";

export default function EventsCreateModule() {

  const asset = UserForm() === 'in' ? GetLocalUser() : GetLocalBusiness();

  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const [form, setForm] = useState(false);
  const [text, setText] = useState('');
  
  const [cred, setCred] = useState([])
  const [sort, setSort] = useState([])

  const [file, setFile] = useState('')
  const [data, setData] = useState({
    name: '',
    memo: '',
    stts: (new Date()).toISOString().substring(0,10),
    cost: 1,
    seat: 100,
    form: 'tickets',
    sort: 'events',
    avtr: '',
    link: '',
    locn: 'https://twitch.tv/xr' + Date.now().toString()
  })

  // useEffect for form validation
  useEffect( () => {
    setForm(false);
    if (data.name!=='' && data.form!=='' && data.sort!=='' && data.link!=='' && file!=='') 
      setForm(true);
  },[data]);

  const SetFileData = async(data) => {
    console.log ('file: ',data);
    
    const reader = new FileReader();
    reader.onloadend = () => {
      // use a regex to remove data url part
      const base64String = reader.result
      .replace("data:", "")
      .replace(/^.+,/, "");
  
      // log to console
      console.log(base64String);
      setFile(base64String);
    };
    reader.readAsDataURL(data);

  }

  const SetFileLink = async(data) => {
    console.log ('link: ',data);
    handleChange("link", data);
  }

  const handleChange = async(key, val) => {
    setData({ ...data, [key]: val });
  }

  const handleSubmit = async e => {
    e.preventDefault();    

    setLoading(true)
    const res = await CreateEvents({
      data: { ...data, avtr: file }, 
      user: asset.usid,
      webb: process.env.REACT_APP_WEBB_SITE_NMBR
    })
    
    setLoading(false)
    console.log (res)
    // if (res.data) history.push(`/${UserForm()}/creds`)

  };

  if (loading){ return ( <> <WebbLoader /> </> ) }

  return (
  <>
    {/* info */}
    <WebbModuleInfo data={{text: 'Create Event with NFT Tickets'}}/>

    {/* form */}
    <form onSubmit={handleSubmit}>

      <div className="">

      {/* <div className="mb-3">
          <div className="row row-cols-4 g-1">
            {sort.map((item,i) => ( !['offer', 'awards'].includes(item) ?
              <div className="col" key={i}>
                <div className={`box-cc rounded-wd hilite text-center ${data.sort===item.name ? 'bg-warning': 'bg-wite'}`}
                  style={{cursor:'pointer'}}
                  onClick={() => handleChange("sort", item.name)}
                >
                  <p className="memo text-color-main">{item.name.toUpperCase()}</p>
                </div>
              </div>
            :''))}
          </div>
        </div> */}

        <div className={`form-group mb-3 ${data.form !=='' && data.sort !=='' ? '' : 'd-none'}`}>
          <label className="form-label small">Event Name  <FormNeeded /></label>
          <input type="text" 
            className="form-control height-md" 
            style={{fontSize:'0.9rem', height:'2.7rem'}}
            value={data.name}
            onChange={({ target }) => {handleChange("name", target.value); setText('');}}
            placeholder="Event Name">
          </input>
        </div>

        <div className={`form-group mb-3 ${data.form !=='' && data.sort !=='' ? '' : 'd-none'}`}>
          <label className="form-label small">Event Memo  <FormNeeded /></label>
          <textarea type="text" 
            className="form-control" 
            style={{fontSize:'0.9rem'}} rows="6"
            value={data.memo}
            onChange={({ target }) => {handleChange("memo", target.value); setText('');}}
            placeholder="">
          </textarea>
        </div>

        <div className={`form-group mb-3 ${data.form !=='' && data.sort !=='' ? '' : 'd-none'}`}>
          <label className="form-label small">Event Date  <FormNeeded /></label>
          <input type="date" 
            className="form-control height-md" 
            style={{fontSize:'0.9rem', height:'2.7rem'}}
            value={data.stts}
            onChange={({ target }) => {handleChange("stts", target.value); setText('');}}
            placeholder="">
          </input>
        </div>

        <div className={`form-group mb-3 ${data.form !=='' && data.sort !=='' ? '' : 'd-none'}`}>
          <label className="form-label small">Ticket Price (XRP)  <FormNeeded /></label>
          <input type="text" 
            className="form-control height-md" 
            style={{fontSize:'0.9rem', height:'2.7rem'}}
            value={data.cost}
            onChange={({ target }) => {handleChange("cost", target.value); setText('');}}
            placeholder="0.00">
          </input>
        </div>

        <div className={`form-group mb-3 ${data.form !=='' && data.sort !=='' ? '' : 'd-none'}`}>
          <label className="form-label small">Number of Seats  <FormNeeded /></label>
          <input type="text" 
            className="form-control height-md" 
            style={{fontSize:'0.9rem', height:'2.7rem'}}
            value={data.seat}
            onChange={({ target }) => {handleChange("seat", target.value); setText('');}}
            placeholder="0.00">
          </input>
        </div>

        <div className={`form-group mb-3 ${data.form !=='' && data.sort !=='' ? '' : 'd-none'}`}>
          <label className="form-label small">Event Location  <FormNeeded /></label>
          <input type="text" 
            className="form-control height-md" 
            style={{fontSize:'0.9rem', height:'2.7rem'}}
            value={data.locn}
            onChange={({ target }) => {handleChange("locn", target.value); setText('');}}
            placeholder="Event Location">
          </input>
        </div>

        {/* file */}
        <div className={`mb-3 ${data.form !=='' && data.sort !=='' ? '' : 'd-none'}`}>
          <CredsFileSaveFirebase 
            name = {'123'} 
            file = {SetFileData}
            link = {SetFileLink}
          />
        </div>

      </div>

      {/* actn */}
      <WebbDividerMedium />      
      <div className={`mb-3 ${data.form !=='' && data.sort !=='' ? '' : 'd-none'}`}>
        <div className="d-grid">
          <button className={`btn height-md rounded-pill ${ form ? 'btn-primary back-color-main' : 'btn-primary back-color-main'}`}
            disabled={!form}
          ><small>Create Event</small>
          </button>
        </div>
      </div>

    </form>


    <WebbDividerMedium/>
    <WebbDividerMedium/>
  </>
  )
}